import type { ClassicalListShelf } from '@jet-app/music-classical/api/types';
import type {
    ItemKind,
    Section,
} from '@jet-app/music-classical/models/section/Section';
import type { FlowAction } from '@jet-app/music-classical/models';

interface ParagraphAttributes {
    text?: string | null;
}

export interface CreditItem {
    title?: string | null;
    subtitle?: string | null;
    segue?: void | FlowAction;
    type: 'info';
}

interface CreditAttributes {
    items?: CreditItem[] | null;
}

export function transformToInfoShelf(
    component: ClassicalListShelf,
    title: string,
    itemKind: ItemKind,
): Section<unknown> {
    let attributes: ParagraphAttributes | CreditAttributes = {};

    switch (itemKind) {
        case 'paragraph':
            attributes = { text: component.text } as ParagraphAttributes;
            break;

        case 'credit':
            attributes = {
                items: component.items,
                backgroundTreatment: 'alternate',
            } as CreditAttributes;
            break;
    }

    return {
        id: component.type,
        sectionKind: 'info',
        itemKind,
        title,
        backgroundTreatment: 'default',
        ...attributes,
    };
}
